import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { BiMoviePlay } from 'react-icons/bi'
import styled from 'styled-components'
import VideoModal from '../Modals/VideoModal'
import { makeCall } from '../../utils/api/makeCall'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'

const StyledVideoButton = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  border: none;
  background-color: transparent;
  opacity: 0;
  width: 0;
  overflow: hidden;
  transition: opacity 0.5s ease, width 0.5s ease;
  &.visible {
    opacity: 1;
    width: 40px;
  }
`
//define what page will show which video. multiple pages can show the same video through correct regular expression
const pageMapping = [
  { regex: /^\/$/, placeholder: 'CMS_Document_Name_Dashboard' },
  { regex: /^\/employees$/, placeholder: 'CMS_Document_Name_Accounts' },
  {
    regex: /^\/products\/personal/,
    placeholder: 'CMS_Document_Name_Order_Personal_Order',
  },
  {
    regex: /^\/newsAdministration$/,
    placeholder: 'CMS_Document_Name_Adminstration_News',
  },
  {
    regex: /^\/placeholdersAdministration$/,
    placeholder: 'CMS_Document_Name_Adminstration_Placeholders',
  },
  {
    regex: /^\/catalogsAdministration$/,
    placeholder: 'CMS_Document_Name_Catalog_Administration',
  },
  {
    regex: /^\/contingentTemplatesAdministration$/,
    placeholder: 'CMS_Document_Name_Contigent_Administration',
  },
  {
    regex: /^\/articlesAdministration$/,
    placeholder: 'CMS_Document_Name_Articlel_Administration',
  },
  {
    regex: /^\/assetTypesAdministration$/,
    placeholder: 'CMS_Document_Name_Asset_Type_Administration',
  },
  {
    regex: /^\/assetGroupsAdministration$/,
    placeholder: 'CMS_Document_Name_Asset_Group_Administration',
  },
  {
    regex: /^\/localstorage\/goodsreceipts$/,
    placeholder: 'CMS_Document_Name_Goods_Receipts',
  },
  {
    regex: /^\/localstorage\/adhocinventories$/,
    placeholder: 'CMS_Document_Name_Ad_Hoc_Inventories',
  },
  {
    regex: /^\/localstorage\/returns$/,
    placeholder: 'CMS_Document_Name_Returns',
  },
  {
    regex: /^\/assets$/,
    placeholder: 'CMS_Document_Assets',
  },
  {
    regex: /^\/assetsordertable$/,
    placeholder: 'CMS_Document_Assets_Order_Table',
  },
  {
    regex: /^\/assetsinventorytable$/,
    placeholder: 'CMS_Document_Assets_Invetory_Table',
  },
  {
    regex: /^\/officeadministration$/,
    placeholder: 'CMS_Document_Office_Administration',
  },
  {
    regex: /^\/costcenteradministration$/,
    placeholder: 'CMS_Document_Cost_Centers_Administration',
  },
  {
    regex: /^\/activitiesAdministration$/,
    placeholder: 'CMS_Document_Activities_Administration',
  },
  {
    regex: /^\/activitiesAdministration$/,
    placeholder: 'CMS_Document_Activities_Administration',
  },
  {
    regex: /^\/entitlementPhasesAdministration$/,
    placeholder: 'CMS_Document_Entitlement_Phases_',
  },
  {
    regex: /^\/appointmenttypes$/,
    placeholder: 'CMS_Document_Name_Appointment_Types',
  },
  {
    regex: /^\/appointmentsadministration$/,
    placeholder: 'CMS_Document_Name_Appointement_Administration',
  },
  {
    regex: /^\/products\/private$/,
    placeholder: 'CMS_Document_Name_Order_Private',
  },
]

const HelpVideoButton = ({ location }) => {
  const [openVideoModal, setOpenVideoModal] = useState(false)
  const [videoUrl, setVideoUrl] = useState('')
  const [, setErrorStates] = useState({})
  const [, setLoadingStates] = useState({})

  const findVideoPageMatch = (location) => {
    let result = {}
    pageMapping.forEach((element) => {
      if (element.regex.test(location.pathname)) {
        result = element
      }
    })
    return result
  }

  const videoPage = useMemo(() => findVideoPageMatch(location), [location])

  const getVideoUrl = useCallback(async () => {
    await makeCall(
      'getAllArticles',
      async () => {
        let url = await apiClient.getJson(
          APIEndpoints.customHTMLVideo(videoPage.placeholder)
        )
        setVideoUrl(url)
      },
      setErrorStates,
      setLoadingStates
    )
  }, [videoPage.placeholder])

  useEffect(() => {
    if (videoPage.placeholder) {
      getVideoUrl()
    } else {
      setVideoUrl('')
    }
  }, [getVideoUrl, videoPage.placeholder])

  const handleClickVideoButton = async () => {
    setOpenVideoModal(true)
  }

  return (
    <>
      <StyledVideoButton
        onClick={handleClickVideoButton}
        className={videoUrl ? 'visible' : ''}
      >
        <BiMoviePlay size='22' />
      </StyledVideoButton>
      {openVideoModal && (
        <VideoModal
          url={videoUrl}
          handleClose={() => {
            setOpenVideoModal(false)
          }}
        />
      )}
    </>
  )
}
export default HelpVideoButton
